import { AnchorHTMLAttributes } from 'react'

import { PulseAnimateMode } from '~/styles/shared/pulseAnimate'

import { HeightClass } from '~/utils/enum/classes'

import { StyledLinkButton } from './styles'

import TextFading from '~/components/TextFading'
import useButtonInteractions from './hooks/useButtonInteractions'
import { ButtonVariant, ImpactClass, TextColor } from './types'

export type LinkButtonProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  variant?: ButtonVariant
  heightClass?: HeightClass
  impactClass?: ImpactClass
  textColor?: TextColor
  disabled?: boolean
  focusable?: boolean
  enableFading?: boolean
  pulseAnimate?: PulseAnimateMode
}

function LinkButton({
  children,
  heightClass = 'regular',
  impactClass = 'navigation',
  textColor = 'white',
  variant = 'primary',
  focusable = true,
  pulseAnimate,
  disabled = false,
  enableFading = false,
  ...htmlLinkProps
}: LinkButtonProps) {
  const { buttonRef, clicked, handleClick, onBlur, onFocus } =
    useButtonInteractions({})

  return (
    <StyledLinkButton
      heightClass={heightClass}
      impactClass={impactClass}
      textColor={textColor}
      variant={variant}
      focusable={focusable}
      tabIndex={focusable ? 0 : -1}
      pulseAnimate={pulseAnimate}
      ref={buttonRef}
      clicked={clicked}
      onClick={handleClick}
      onMouseEnter={onFocus}
      onMouseLeave={onBlur}
      $disabled={disabled}
      aria-disabled={disabled}
      {...htmlLinkProps}
    >
      {enableFading ? <TextFading>{children}</TextFading> : children}
    </StyledLinkButton>
  )
}

export default LinkButton
